import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { CellContext } from '@tanstack/react-table';

export interface TariffListCurrencyCellProps
  extends CellContext<TariffModel, TariffModel['currency']> {}

export const TariffListCurrencyCell = (
  props: TariffListCurrencyCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
